<div class="container-fluid module-detail-component">
    <section class="preview-box font-4xl row justify-content-center">
        <div class="col-10">
            <div class="row h-100 justify-content-between">
                <div class="title-wrap w-100 px-0" *ngIf="module">
                    <div class="sub-title font-sm mt-4 d-flex align-items-center justify-content-between">
                        <div class="meta float-start">
                            <span data-uit="module-detail-version">{{ shownVersion?.versionNumber | moduleVersionNumber }}</span>
                            <span>{{ module?.sortOrderDate | date }}</span>
                            <span *ngIf="isInWorkspace && module?.latestPublicVersion">
                                <a *ngIf="!isReadOnly" [routerLink]="latestPublicDetailLink">
                                    {{ 'MODULES.DETAIL.LATEST_PUBLIC_VERSION' | translate }} {{ module?.latestPublicVersion?.versionNumber }}
                                </a>
                                <span *ngIf="isReadOnly"
                                    >{{ 'MODULES.DETAIL.LATEST_PUBLIC_VERSION' | translate }} {{ module?.latestPublicVersion?.versionNumber }}</span
                                >
                            </span>
                        </div>
                        <div class="action-bar d-flex justify-content-start flex-row align-items-center">
                            <ca-compliant-badge *ngIf="true" presentationType="full" class="banner isCompliant me-2"> </ca-compliant-badge>
                            <ca-module-badge *ngIf="isInWorkspace && module && moduleLabelKey" [labelKey]="moduleLabelKey"></ca-module-badge>
                            <button
                                *ngIf="!isReadOnly && isEditable"
                                type="button"
                                class="btn ca-btn-icon"
                                (click)="editModule()"
                                data-uit="module-detail-edit-button"
                                [title]="'GENERAL.EDIT' | translate"
                            >
                                <ca-icon name="pen" size="s"></ca-icon>
                            </button>
                            <button
                                *ngIf="!isReadOnly && (isDeletable || isUnshareable)"
                                type="button"
                                class="btn ca-btn-icon"
                                (click)="deleteOrUnshareModule()"
                                data-uit="module-detail-delete-button"
                                [title]="'GENERAL.DELETE' | translate"
                            >
                                <ca-icon name="trash" size="s"></ca-icon>
                            </button>
                        </div>
                    </div>
                    <h1 [title]="module?.title" data-uit="module-detail-module-name">{{ module.title }}</h1>
                </div>
                <div class="col-md-auto mb-3 h-100 px-0">
                    <div
                        class="image-box float-end d-none d-lg-block"
                        [style.backgroundImage]="'url(' + shownVersion?.image + ')'"
                        data-uit="module-detail-image"
                    ></div>
                </div>
            </div>
        </div>
    </section>
    <section class="row py-5 justify-content-center">
        <div class="col-10">
            <div class="row">
                <div class="col-md-9 ps-0">
                    <h3>{{ 'MODULES.DETAIL.SUMMARY' | translate }}</h3>
                    <p class="module-summary" data-uit="module-detail-summary">{{ shownVersion?.summary }}</p>
                </div>
                <div class="col-md-3 text-end">
                    <div *ngIf="isLoggedIn" class="field-title font-sm">{{ 'MODULES.DETAIL.CREATED_BY' | translate }}</div>
                    <div *ngIf="isLoggedIn && author?.id">
                        <a class="profile field-value" *ngIf="!isReadOnly" [routerLink]="['/user/profile', author?.id]" data-uit="module-detail-created-by"
                            >{{ author | fullName }}
                        </a>
                        <span *ngIf="isReadOnly" class="profile field-value font-m">{{ author | fullName }}</span>
                    </div>
                    <div class="field-title font-sm mt-3" data-uit="module-detail-category-title">{{ 'GENERAL.CATEGORY' | translate }}</div>
                    <div class="field-value font-m font-weight-bold" data-uit="module-detail-category ">{{ module?.categoryName || '-' }}</div>
                </div>
            </div>
        </div>
    </section>
    <section class="row py-5 justify-content-center">
        <div class="col-10">
            <div class="row">
                <div class="col-md-9 ps-0">
                    <h3>{{ 'MODULES.DETAIL.DESCRIPTION' | translate }}</h3>
                    <ca-quill-editor-wrapper
                        placeholder=""
                        [ngModel]="shownVersion?.description"
                        [readOnly]="true"
                        [modules]="{ toolbar: false }"
                        data-uit="module-detail-description"
                    ></ca-quill-editor-wrapper>
                </div>
                <div class="col-md-3 d-flex flex-column" *ngIf="!isReadOnly && isLoggedIn && module">
                    <div class="w-100" [ngbTooltip]="disableCreateWorkflowButton() ? createWorkflowDisabledMessage : ''">
                        <button
                            type="button"
                            class="btn btn-primary mt-2 button-unified-width w-100"
                            (click)="createWorkflowWithModule(module)"
                            [disabled]="disableCreateWorkflowButton()"
                            data-uit="module-detail-create-new-workflow"
                        >
                            {{ 'WORKFLOWS.CREATE_WORKFLOW' | translate }}
                        </button>
                    </div>
                    <div class="w-100" [ngbTooltip]="!isBuildStatusSucceeded ? moduleDisabledMessage : ''">
                        <button
                            type="button"
                            class="btn btn-primary mt-2 button-unified-width w-100"
                            *ngIf="!isReadOnly && isInWorkspace && isPublishable"
                            [disabled]="!isBuildStatusSucceeded"
                            (click)="publishModule()"
                            data-uit="publish-module-button"
                        >
                            {{ 'MODULES.PUBLISH_MODULE' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section *ngIf="isMine && isInWorkspace" class="row py-5 justify-content-center">
        <div class="col-10">
            <div class="row">
                <div class="col-md-9 p-0">
                    <h3>{{ 'MODULES.DETAIL.SHARING.MODULE_SHARING' | translate }}</h3>
                    <div *ngIf="module?.shares?.length === 0">
                        <div class="sharedNobody-content">{{ 'MODULES.DETAIL.SHARING.NOT_SHARED_YET' | translate }}</div>
                        <div class="inviteMembers-content">
                            <p>{{ 'MODULES.DETAIL.SHARING.INVITE_MEMBERS' | translate }}</p>
                        </div>
                    </div>
                    <div *ngIf="module?.shares?.length > 0">
                        <div>
                            {{ 'MODULES.DETAIL.SHARING.SHARED_WITH' | translate }} {{ module.shares.length }}
                            <span *ngIf="module?.shares?.length === 1">{{ 'MODULES.DETAIL.SHARING.PEER' | translate }}</span>
                            <span *ngIf="module?.shares?.length > 1">{{ 'MODULES.DETAIL.SHARING.PEERS' | translate }}</span>
                        </div>
                        <div class="d-flex flex-wrap justify-content-start mt-3">
                            <div
                                *ngFor="let user of module.shares"
                                class="me-2"
                                [ngbTooltip]="user | fullName"
                                data-uit="module-detail-page-share-user-list-item"
                            >
                                <label class="name-form" type="text">
                                    <a *ngIf="user.picture" [routerLink]="['/user/profile', user.userId]">
                                        <img [src]="user.picture" class="profile-img" />
                                    </a>
                                    <a *ngIf="!user.picture" class="initials font-m text-center" [routerLink]="['/user/profile', user.userId]">
                                        {{ user | initials }}
                                    </a>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="!isReadOnly" class="col-md-3 d-flex flex-column align-items-end">
                    <button type="button" class="btn btn-primary button-unified-width w-100" (click)="invite()" data-uit="module-detail-manage-shares-btn">
                        {{ 'MODULES.DETAIL.SHARING.MANAGE_SHARES' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </section>
    <section
        class="row justify-content-center build-status-section bg-surface-medium-emphasis"
        *ngIf="!isReadOnly && (isMine || isSharedWithWriteAccess) && isInWorkspace && module?.repositoryId"
    >
        <div class="col-10">
            <ca-repository-item [repositoryId]="module.repositoryId" (onRepositoryUpdate)="updateRepositoryUrl($event)" class="mb-3"></ca-repository-item>
            <div class="row pb-3">
                <div class="col-md-9 git-description">
                    <p [innerHtml]="'MODULES.DETAIL.GIT.NEEDED_DOCUMENTS' | translate"></p>
                    <p>
                        {{ 'MODULES.DETAIL.GIT.FURTHER_INFORMATION_1' | translate
                        }}<a [href]="wikiUrl" target="_blank" rel="noopener">{{ 'MODULES.DETAIL.GIT.DOCS' | translate }}</a>
                        {{ 'MODULES.DETAIL.GIT.FURTHER_INFORMATION_2' | translate }}
                        <a class="contact-us text-lowercase" (click)="openContactUs()">{{ 'MENU.CONTACT' | translate }}</a>
                        {{ 'MODULES.DETAIL.GIT.FURTHER_INFORMATION_3' | translate }}
                    </p>
                </div>
                <div class="col-md-3 d-flex flex-column align-items-end">
                    <button type="button" class="btn btn-ghost" (click)="isCodeExpanded = !isCodeExpanded">
                        <span class="me-2">{{ 'MODULES.DETAIL.GIT.MODULE_CODE' | translate }}</span>
                        <ca-icon name="arrow-up" size="s" *ngIf="isCodeExpanded"></ca-icon>
                        <ca-icon name="arrow-down" size="s" *ngIf="!isCodeExpanded"></ca-icon>
                    </button>
                </div>
            </div>
        </div>
    </section>
    <div #flowSection></div>
    <section
        *ngIf="!isReadOnly && (isMine || isSharedWithWriteAccess) && isInWorkspace"
        class="git-section steps-section justify-content-center expandable spec-generation row py-5"
        [hidden]="!isCodeExpanded"
    >
        <div class="col-10 d-flex justify-content-between">
            <div class="d-flex flex-column">
                <div class="section-title font-l mb-2">{{ 'MODULES.DETAIL.PREREQUISITES' | translate }}</div>
                <div>{{ 'MODULES.DETAIL.PREREQUISITES_DESC' | translate }}</div>
                <div class="prerequisites-list d-flex flex-column my-3">
                    <div>- <a href="https://git-scm.com/" target="_blank" rel="noopener">Git </a>{{ 'MODULES.DETAIL.GIT_DESC' | translate }}</div>
                    <div>- <a href="https://www.docker.com/" target="_blank" rel="noopener">Docker </a>{{ 'MODULES.DETAIL.DOCKER_DESC' | translate }}</div>
                </div>
                <div class="d-flex align-items-center">
                    <a href="https://docs.apeer.com/create-modules/module-debugging" target="_blank" rel="noopener" class="d-flex align-items-center">
                        {{ 'MODULES.DETAIL.CHECK_DOCS' | translate }}
                        <ca-icon name="external-link" size="s" class="ms-2"></ca-icon>
                    </a>
                </div>
            </div>
            <ca-card
                data-uit="dashboard-create-module-tile"
                class="col-6 m-3"
                title="{{ 'MY_WORKSPACE.MY_ACTIVITIES.TILES_SECTION.CREATE_MODULE.TITLE' | translate }}"
                imageSrc="assets/images/activity-page/create_module_thumbnail.png"
                videoUrl="https://www.youtube.com/watch?v=LxTnzInLszg&feature=youtu.be"
                buttonText="{{ 'MY_WORKSPACE.MY_ACTIVITIES.TILES_SECTION.CREATE_MODULE.BUTTON_TEXT' | translate }}"
                description="{{ 'MY_WORKSPACE.MY_ACTIVITIES.TILES_SECTION.CREATE_MODULE.DESC' | translate }}"
            ></ca-card>
        </div>
        <div class="col-12">
            <swiper fxFlex="auto" [config]="config" (realIndexChange)="onIndexChange($event)" data-uit="module-detail-swiper">
                <ng-template swiperSlide class="cursor-pointer" *ngFor="let moduleStep of moduleSteps; let index = index">
                    <div fxLayout="column" fxLayoutAlign="center center" fxFlexFill class="mx-2">
                        <div class="step">
                            <div class="font-xxl">0{{ index + 1 }}.</div>
                            <h3>{{ moduleStep.title | translate }}</h3>
                            <div class="font-sm mt-4">{{ moduleStep.description | translate }}</div>
                        </div>
                    </div></ng-template
                >
            </swiper>
            <div class="mt-3">
                <div class="row justify-content-center mt-5">
                    <div class="col-10" *ngIf="stepIndex === 0">
                        <div class="d-flex justify-content-start align-items-center">
                            <div class="input-group w-50 url me-4">
                                <input
                                    #gitUrlTextBox
                                    type="text"
                                    class="form-control git-url-value me-1"
                                    [value]="'git clone ' + repositoryUrl"
                                    readonly
                                    data-uit="module-detail-git-link"
                                />
                                <button
                                    type="button"
                                    class="btn btn-secondary"
                                    [ngxClipboard]="gitUrlTextBox"
                                    (cbOnSuccess)="t.open()"
                                    ngbTooltip="Text copied!"
                                    triggers="manual"
                                    container="body"
                                    #t="ngbTooltip"
                                >
                                    <ca-icon name="copy" size="s"></ca-icon>
                                </button>
                            </div>
                            <div class="d-flex align-items-center">
                                <span>{{ 'MODULES.DETAIL.STEPS.ONE.CONTENT.FORGOT_CREDENTIALS' | translate }}</span>
                                <button type="button" class="btn btn-link ms-2" (click)="showCredentials = !showCredentials">
                                    {{ 'GENERAL.CLICK_HERE' | translate }}
                                </button>
                            </div>
                        </div>
                        <div [innerHTML]="'MODULES.DETAIL.STEPS.ONE.CONTENT.GIT_MORE_INFO' | translate" class="mt-2"></div>
                        <div class="row" [hidden]="!showCredentials">
                            <div class="col">
                                <ca-git-credential [showCredentials]="showCredentials" class="w-100"></ca-git-credential>
                            </div>
                        </div>
                    </div>
                    <div class="col-10" [class.d-none]="stepIndex !== 1">
                        <div class="mb-4" [innerHTML]="'MODULES.DETAIL.STEPS.TWO.CONTENT.INSTRUCTION' | translate"></div>
                        <button type="button" class="btn large-btn btn-primary mb-4" data-uit="module-detail-generate-spec-button" (click)="editSpecModule()">
                            {{ 'MODULES.DETAIL.STEPS.TWO.CONTENT.GENERATE_SPEC' | translate }}
                        </button>
                        <div>{{ 'MODULES.DETAIL.STEPS.TWO.CONTENT.NOTE' | translate }}</div>
                    </div>
                    <div class="col-10" [class.d-none]="stepIndex !== 2">
                        <div class="mb-4">
                            {{ 'MODULES.DETAIL.STEPS.THREE.CONTENT.INSTRUCTION' | translate }}
                            <div class="d-flex flex-wrap mt-4">
                                <a
                                    *ngFor="let programmingLanguage of programmingLanguages; let index = index"
                                    href="{{ programmingLanguage.url }}"
                                    target="_blank"
                                    rel="noopener"
                                    class="m-2 language-container d-flex justify-content-center align-items-center flex-column"
                                >
                                    <div [inlineSVG]="programmingLanguage.icon" [removeSVGAttributes]="['stroke']" [cacheSVG]="true" class="p-2"></div>
                                    <div class="pt-3">{{ programmingLanguage.title }}</div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-10" [class.d-none]="stepIndex !== 3">
                        <div class="mb-4" [innerHTML]="'MODULES.DETAIL.STEPS.FOUR.CONTENT.INSTRUCTION' | translate"></div>
                    </div>
                    <div class="col-10" [class.d-none]="stepIndex !== 4">
                        <div class="mb-4">
                            {{ 'MODULES.DETAIL.STEPS.FIVE.CONTENT.INSTRUCTION' | translate }}
                        </div>
                        <span class="code-content p-2"> git add --all </span>
                        <div class="my-4">
                            {{ 'MODULES.DETAIL.STEPS.FIVE.CONTENT.GIT_ADD_INFO' | translate }}
                        </div>
                        <span class="code-content p-2"> git commit -m “some message” </span>
                        <div class="my-4">
                            {{ 'MODULES.DETAIL.STEPS.FIVE.CONTENT.GIT_COMMIT_INFO' | translate }}
                        </div>
                        <span class="code-content p-2"> git push </span>
                        <div class="my-4">
                            {{ 'MODULES.DETAIL.STEPS.FIVE.CONTENT.GIT_PUSH_INFO' | translate }}
                        </div>
                    </div>
                    <div class="col-10" [class.d-none]="stepIndex !== 5">
                        <div class="mb-4">
                            {{ 'MODULES.DETAIL.STEPS.SIX.CONTENT.INSTRUCTION' | translate }}
                        </div>
                        <button
                            type="button"
                            class="btn btn-primary mt-2 button-unified-width"
                            (click)="createWorkflowWithModule(module)"
                            data-uit="module-detail-create-new-workflow"
                        >
                            {{ 'WORKFLOWS.CREATE_WORKFLOW' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section *ngIf="isLoggedIn && isOpenSourceModule && codeDownloadUrl?.length > 0" class="row justify-content-center py-5">
        <div class="col-10">
            <div class="row">
                <div class="open-source-code col-md-9">
                    <h3>{{ 'MODULES.DETAIL.DOWNLOAD_CODE' | translate }}</h3>
                    <ng-container *ngIf="isInWorkspace && isMine; notMine">{{ 'MODULES.DETAIL.DOWNLOAD_CODE_TEXT_MINE' | translate }}</ng-container>
                    <ng-template #notMine>{{ 'MODULES.DETAIL.DOWNLOAD_CODE_TEXT' | translate }}</ng-template>
                </div>
                <div class="col-md-3 d-flex flex-column align-items-end">
                    <a class="btn btn-ghost" data-uit="module-detail-download-code-button" target="_blank" rel="noopener" href="{{ codeDownloadUrl }}">{{
                        'MODULES.DETAIL.DOWNLOAD_CODE' | translate
                    }}</a>
                </div>
            </div>
        </div>
    </section>
    <section *ngIf="isMine && isInWorkspace && module.submissions?.length > 0" class="row justify-content-center py-5">
        <div class="col-10">
            <div class="row">
                <div class="col-md-9"></div>
                <div class="col-md-3 d-flex flex-column align-items-end">
                    <button type="button" class="btn btn-ghost" (click)="isHistoryExpanded = !isHistoryExpanded">
                        <span class="me-2">Submission History</span>
                        <ca-icon name="arrow-up" size="s" *ngIf="isHistoryExpanded"></ca-icon>
                        <ca-icon name="arrow-down" size="s" *ngIf="!isHistoryExpanded"></ca-icon>
                    </button>
                </div>
            </div>
        </div>
    </section>
    <section
        *ngIf="isMine && isInWorkspace && module.submissions?.length > 0 && isHistoryExpanded"
        class="row justify-content-center no-border submission-section"
    >
        <div class="col-10">
            <table class="table table-condensed mt-3">
                <thead>
                    <tr>
                        <th>{{ 'MODULES.DETAIL.SUBMISSION_DATE' | translate }}</th>
                        <th>{{ 'MODULES.DETAIL.STATUS' | translate }}</th>
                        <th>{{ 'COMMENTS.COMMENT' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let submissionItem of module.submissions">
                        <td>{{ submissionItem.createdAt | date: 'dd.MM.yyyy | HH:mm:ss' }}</td>
                        <td [ngClass]="{ 'ca-color-error': submissionItem.state === 'Rejected' }">
                            <div class="d-flex">
                                {{ submissionItem.state | moduleSubmissionStateTranslationKey | translate }}
                                <ca-icon
                                    name="error"
                                    size="s"
                                    *ngIf="submissionItem.state === 'Rejected'"
                                    class="ca-color-icon-error ms-1"
                                    [removeSVGAttributes]="['stroke']"
                                ></ca-icon>
                            </div>
                        </td>
                        <td class="comments">{{ submissionItem.commentToProducer }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>
</div>
